import { render, staticRenderFns } from "./widget-longlat.vue?vue&type=template&id=c50f7cbe&scoped=true"
import script from "./widget-longlat.vue?vue&type=script&lang=js"
export * from "./widget-longlat.vue?vue&type=script&lang=js"
import style0 from "./widget-longlat.vue?vue&type=style&index=0&id=c50f7cbe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c50f7cbe",
  null
  
)

export default component.exports